import api from '@rental-manager/utils/api';
import postingUtils from '@rental-manager/utils/postingUtils';
import { SAVE_LISTING_ALIAS, SAVE_LISTING_DETAILS } from '@rental-manager/constants/ActionConstants';
import { logError } from '@zg-rentals/log-error';

const PropertiesActions = {
  // add boolean for restrictions
  getDetails: (propertyId: string) => (dispatch, getState) =>
    // pass boolean heres
    dispatch(api.users.properties.getDetails(propertyId))
      .then((result) => {
        if (!result.success) {
          return Promise.reject(result.error);
        }
        const dataForForm: any = postingUtils.transformDatafromApi(result.response);
        dataForForm.propertyId = propertyId;
        return dataForForm;
      })
      .catch((err) => {
        logError({ error: err, context: { details: 'PropertiesActions.getDetails', user: getState().user } });
        return Promise.reject(err);
      }),

  saveListingAlias: (listingAlias: string) => ({
    type: SAVE_LISTING_ALIAS,
    listingAlias,
  }),
  saveListingDetails: (listingDetails) => ({
    type: SAVE_LISTING_DETAILS,
    listingDetails,
  }),
};

export default PropertiesActions;
